import { useCallback } from 'react';

type P = {
  type: 'attendee' | 'presenter';
};

export const useGetInvitationTokenKind = () =>
  useCallback(({ type }: P) => {
    switch (type) {
      case 'attendee':
        return 'event_attendee_invitation';
      case 'presenter':
        return 'event_presenter_invitation';
    }
  }, []);
